"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _excluded = ["bgClassName", "iconClassName"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Clear = function Clear(_ref) {
  var bgClassName = _ref.bgClassName,
      iconClassName = _ref.iconClassName,
      other = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    width: "24",
    viewBox: "0 0 24 24",
    fill: "#004864"
  }, other), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21,24H3a2.94645,2.94645,0,0,1-3-2.89191Q-.001,21.054,0,21V3A2.94645,2.94645,0,0,1,2.89191,0Q2.946-.001,3,0H21a2.94645,2.94645,0,0,1,3,2.89191Q24.001,2.946,24,3V21a2.94645,2.94645,0,0,1-2.89191,3Q21.054,24.001,21,24Z",
    className: bgClassName
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.76409,12.02867,19.52242,6.224a1.43119,1.43119,0,0,0,0-1.87248,1.40273,1.40273,0,0,0-1.85753,0h0l-5.66545,5.711L6.2411,4.35152a1.40272,1.40272,0,0,0-1.85752,0,1.33437,1.33437,0,0,0,0,1.87248l5.75833,5.80467-5.75833,5.711a1.43116,1.43116,0,0,0,0,1.87248,1.4027,1.4027,0,0,0,1.85752,0l5.75834-5.80468,5.75833,5.80468a1.30606,1.30606,0,0,0,1.85752,0,1.33158,1.33158,0,0,0,0-1.87248Z",
    fill: "#fff",
    className: iconClassName
  }));
};

Clear.defaultProps = {
  bgClassName: null,
  iconClassName: null
};
var _default = Clear;
exports["default"] = _default;